import React from "react";

export const PaymentContext = React.createContext({
    parent: null,
});